export const MaxIssueLinksStatsCount = 9;
